module.exports = __webpack_public_path__ + "img/img_result-stand-01.40a077b7.png";